// Entry point pentru aplicația React
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { SpeedInsights } from "@vercel/speed-insights/react";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { queryClient } from "./queryClient";
// Service worker cleanup - imported conditionally to avoid side effects
// import "./utils/serviceWorkerCleanup";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
        <SpeedInsights />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
